export const ENABLE_YOUR_ACCOUNT_HEADER = "enable-your-account-header";
export const ENABLE_YOUR_ACCOUNT_CONTENT_1 = "enable-your-account-content-1";
export const ENABLE_YOUR_ACCOUNT_FORM = "enable-your-account-form";
